// extracted by mini-css-extract-plugin
export default {"CustomCheckbox":"c75E1G5H"};